// John Eldhose 20210525
import React, { Component } from 'react';
import { setLoginPage } from './lib/LoginPage';
import Loading from './lib/Loading';

class TeaserForum extends Component {

  componentDidMount() {
    setLoginPage({ url: '/forum', opts: [window.location.search] });
    window.location = '/login';
  }

  render() { return <Loading minHeight={350} />; }
}

export default TeaserForum;



// WEBPACK FOOTER //
// ./src/components/TeaserForum.js